/**
 * Validator Module
 * Xử lý validation cho form
 */

import * as StateManager from './state-manager.js';
import { scrollToFieldAndHighlight } from './utils.js';

/**
 * Validate phone number format
 */
export function validatePhoneNumber() {
    const $cache = StateManager.getCache();
    const phone = $cache.phone.val().trim();

    // If empty, don't show error (will be caught by main validation)
    if (!phone) {
        $cache.phone.removeClass('ktvhvn-field-error');
        $cache.phoneError.hide();
        return true;
    }

    // Remove spaces and special characters for validation
    const cleanPhone = phone.replace(/[\s\-\.]/g, '');

    // Check if only contains digits
    if (!/^\d+$/.test(cleanPhone)) {
        $cache.phone.addClass('ktvhvn-field-error');
        $cache.phoneError.text('SĐT chỉ được chứa số').show();
        return false;
    }

    // Get specific error message
    let errorMsg = '';
    const startsWithZero = cleanPhone.startsWith('0');
    const hasCorrectLength = cleanPhone.length === 10;

    if (startsWithZero && !hasCorrectLength) {
        errorMsg = 'SĐT phải có đủ 10 số';
    } else if (!startsWithZero && hasCorrectLength) {
        errorMsg = 'SĐT phải bắt đầu bằng số 0';
    } else if (!startsWithZero && !hasCorrectLength) {
        errorMsg = 'SĐT phải bắt đầu bằng số 0 và có đủ 10 số';
    }

    if (errorMsg) {
        $cache.phone.addClass('ktvhvn-field-error');
        $cache.phoneError.text(errorMsg).show();
        return false;
    }

    // Valid phone number
    $cache.phone.removeClass('ktvhvn-field-error');
    $cache.phoneError.hide();
    return true;
}

/**
 * Validate customer info form
 */
export function validateForm() {
    const $cache = StateManager.getCache();

    // Remove all previous error states
    $cache.name.removeClass('ktvhvn-field-error');
    $cache.phone.removeClass('ktvhvn-field-error');
    $cache.phoneError.hide();

    const name = $cache.name.val().trim();
    const phone = $cache.phone.val().trim();

    if (!name) {
        scrollToFieldAndHighlight($cache.name);
        return false;
    }

    if (!phone) {
        scrollToFieldAndHighlight($cache.phone);
        return false;
    }

    // Validate phone format
    if (!validatePhoneNumber()) {
        scrollToFieldAndHighlight($cache.phone);
        return false;
    }

    return true;
}
